<ng-template #modal let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Logs de avaliação</h4>
  </div>

  <div class="modal-body pt-0 mt-0 tarja-edit">

    <div class="row mt-3 h350">
      <div class="col-md-1 box-left">
        <span class="material-icons icon-theme">
          manage_history
        </span>
      </div>

      <div class="col-md-11">

        <div class="row" *ngIf="logsAvaliacao.length">
          <div class="col-md-12">

            <div class="box-table h350">
              <table>
                <thead>
                  <tr>
                    <th>Data/Hora</th>
                    <th>OS</th>
                    <th>Usuario</th>
                    <th>Status</th>
                    <th>Observação avaliação</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr *ngFor="let log of logsAvaliacao">
                    <td class="text-center">{{ log.dataHora | date:'dd/MM/yyyy HH:mm'}}</td>
                    <td class="text-center">{{ log.osId | zerosEsquerda: 5 }}</td>
                    <td>{{ log.usuario.login }}</td>
                    <td class="text-center">
                      <span class="badge badge-pill fw mr-2"
                        [ngStyle]="{ 'background-color': bgCoresStatus[log.statusOS] }">
                        {{ statusOS[log.statusOS] }}
                      </span>

                    </td>
                    <td class="text-left">{{ log.observacaoAvaliacao }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!logsAvaliacao.length">
          <div class="col-md-12"
            style="height: 250px; display: flex; flex-direction: column; align-items: center; align-content: center;">
            <h4 class="text-danger">OS {{inputOSId}} não tem Logs de avaliação ainda.</h4>
          </div>
        </div>


      </div>


    </div>
  </div>
  <div class="modal-footer">
    <div class="col-md-6"></div>
    <div class="col-md-3">
      <button type="button" class="btn btn-secondary btn-block" (click)="fecharModal(c)">Retornar</button>
    </div>

  </div>
</ng-template>